<template>
    <div class="toolbar-wrap">
        <div>
            <p class="field-title" style="margin-left: 0.5rem">
                Company Contacts
                <Tooltip description="Manage your company's contact persons." />
            </p>
        </div>
        <Button :disabled="isChannel || disableEditForDifferentOrigin" label="Add Contact" class="mr-2 inline-block add-new-btn" @click="openNew" />

    </div>
    <div class="table-wrap">
        <table class="contacts-table" v-if="contacts?.length">
            <thead>
                <tr>
                    <th>Actions</th>
                    <th>Name</th>
                    <th>Title</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Primary Contact</th>
                    <th>Escalation Contact</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(contact, index) in contacts" :key="index">
                    <td class="actions-column">
                        <div class="actions-column-inner">

                            <Button :disabled="isChannel || disableEditForDifferentOrigin" icon="pi pi-pencil" class="p-button-rounded p-button-warning mr-2"

                            @click="editContact(contact, index)" />
                        <Button :disabled="isChannel || disableEditForDifferentOrigin" icon="pi pi-trash" class="p-button-rounded p-button-warning"
                            @click="deleteContact(contact, index)" />
                        </div>
                    </td>
                    <td>{{ contact.name }}</td>
                    <td>{{ contact.title }}</td>
                    <td>{{ contact.email }}</td>
                    <td>{{ contact.phone }}</td>
                    <td class="center-column">
                        <i :class="['pi', contact.isPrimary ? 'pi-check' : 'pi-times']"></i>
                    </td>
                    <td class="center-column">
                        <i :class="['pi', contact.isEscalation ? 'pi-check' : 'pi-times']"></i>
                    </td>
                </tr>
            </tbody>
        </table>

        <Dialog :draggable="false" v-model:visible="contactDialog" :style="{ width: '600px' }" header="Contact Details" :modal="true"
            class="p-fluid">
            <div class="field">
                <label for="name">Name</label>
                <InputText id="name" v-model="contact.name" required="true" />
            </div>

            <div class="field">
                <label for="title">Title</label>
                <InputText id="title" v-model="contact.title" required="true" />
            </div>

            <div class="field">
                <label for="email">Email</label>
                <InputText 
                    id="email" 
                    v-model="contact.email" 
                    required="true" 
                    type="email" 
                />
                <small v-if="contact.email && !isValidEmail(contact.email)" class="error-msg">
                    Please enter a valid email address
                </small>
            </div>

            <div class="field">
                <label for="phone">Phone</label>
                <InputText 
                    id="phone" 
                    v-model="contact.phone" 
                    required="true" 
                    maxlength="16" 
                    @input="validatePhoneInput"
                />
                <small v-if="contact.phone && !isValidPhone(contact.phone)" class="error-msg">
                    Please enter a valid phone number (e.g., (123) 123-1234, 123-123-1234, +1 415 555 2671)
                </small>
            </div>

            <div class="field-checkbox mb-1">
                <Checkbox id="primary" v-model="contact.isPrimary" :binary="true" 
                    @change="handlePrimaryChange" />
                <label for="primary" style="margin-left: 1rem">Set as Primary Contact</label>
            </div>


            <div class="field-checkbox">
                <Checkbox id="escalation" v-model="contact.isEscalation" :binary="true" />
                <label for="escalation" style="margin-left: 1rem">Set as Escalation Contact</label>
            </div>

            <template #footer>
                <Button label="Cancel" class="p-button p-component p-button-outlined button" @click="hideDialog" />
                <Button v-if="editIndex === null" label="Add" class="p-button p-component button"
                    @click="onContactSave" />
                <Button v-else label="Update" class="p-button p-component button" @click="onContactSave" />
            </template>
        </Dialog>

        <Dialog :draggable="false" v-model:visible="deleteContactDialog" :style="{ width: '450px' }" header="Confirm" :modal="true">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle mr-3" style="font-size: 1.75rem; margin-right: 0.5rem" />
                <span v-if="contact">Are you sure you want to delete <b>{{ contact.name }}</b>?</span>
            </div>
            <template #footer>
                <Button label="No" class="p-button p-component p-button-outlined button"
                    @click="deleteContactDialog = false" />
                <Button label="Yes" class="p-button p-component button" @click="onConfirmDeleteContact" />
            </template>
        </Dialog>
    </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import Tooltip from '../Tooltip.vue';

export default {
    name: 'ProfileContacts',
    props: ['saveInd', 'contactValues', 'isChannel', 'disableEditForDifferentOrigin'],
    components: {
        Tooltip,
    },
    data() {
        return {
            contacts: [],
            contactDialog: false,
            deleteContactDialog: false,
            contact: {},
            submitted: false,
            editIndex: null,
            deleteContactIndex: null,
            intializeOnce: true,
            paginationData: { columnOffset: 0 }
        };
    },
    setup() {
        const v = useVuelidate({ $stopPropagation: true });
        return { v };
    },
    watch: {
        v$: function () {
            if (this.v$.$dirty) {
                this.validationCall();
            }
        },
        saveInd() {
            if (this.saveInd) {
                this.validationCall();
            }
        },
        contactValues: {
            immediate: true,
            handler(newVal) {
                try {
                    console.log('Received contactValues:', newVal);
                    this.contacts = newVal || [];
                    console.log('Updated contacts:', this.contacts);
                } catch (err) {
                    console.error('Error in contactValues watch:', err);
                }
            }
        },
    },
    methods: {
        handlePrimaryChange(event) {
            if (event === true) {
                const existingPrimary = this.contacts.some(c =>  {

                console.log("Values >>", {"C": c, "EI": this.editIndex, "CI": this.contacts.indexOf(c)})
                return  c.isPrimary && 
                (this.editIndex === null || this.contacts.indexOf(c) !== this.editIndex)
                }
                );
                
                if (existingPrimary) {
                    this.contact.isPrimary = false;
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Only one primary contact is allowed',
                        life: 3000,
                    });
                }
            }
        },
        checkAndUpdateEscalationContact() {
            if (this.contact.isEscalation) {
                this.contacts.forEach(contact => {
                    if (contact !== this.contact) {
                        contact.isEscalation = false;
                    }
                });
            }
        },
        onPage(event) {
            this.paginationData = {
                page: event?.page,
                pageCount: event?.pageCount,
                rows: event?.rows,
                columnOffset: event?.page * event?.rows,
            };
        },
        openNew() {
            this.contact = {};
            this.submitted = false;
            this.contactDialog = true;
        },
        hideDialog() {
            this.contactDialog = false;
            this.submitted = false;
            this.editIndex = null;
        },
        editContact(contact, index) {
            this.contact = { ...contact };
            this.editIndex = this.paginationData?.columnOffset + index;
            this.contactDialog = true;
        },
        deleteContact(contact, index) {
            this.contact = contact;
            this.deleteContactIndex = this.paginationData?.columnOffset + index;
            this.deleteContactDialog = true;
        },
        onConfirmDeleteContact() {
            this.contacts.splice(this.deleteContactIndex, 1);
            this.deleteContactDialog = false;
            this.contact = {};
            this.validationCall();
        },
        validatePhoneInput(event) {
            // Allow digits, spaces, parentheses, hyphens, dots, and + at the beginning
            const value = event.target.value;
            if (value !== value.replace(/[^\d\s()\-+.]/g, '')) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Invalid Input',
                    detail: 'Only numbers, spaces, parentheses, hyphens, dots, and + prefix are allowed',
                    life: 2000,
                });
                return;
            }
        },
        isValidEmail(email) {
            const emailRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return emailRegex.test(email);
        },
        isValidPhone(phone) {
            // This regex allows:
            // - Optional + at start
            // - Optional country code
            // - Optional spaces, parentheses, hyphens, and dots
            // - Between 10 and 15 digits total (including country code)
            const phoneRegex = /^\+?[0-9\s\-().]{10,15}$/;
            return phoneRegex.test(phone);
        },
        onContactSave() {
             // Required field validations
             if (!this.contact.name || this.contact.name.trim() === '') {
                return this.$toast.add({
                    severity: 'error',
                    summary: 'Required Field',
                    detail: 'Name is required',
                    life: 3000,
                });
            }

            if (!this.contact.email) {
                return this.$toast.add({
                    severity: 'error',
                    summary: 'Required Field',
                    detail: 'Email is required',
                    life: 3000,
                });
            }

            // Email format validation
            if (!this.isValidEmail(this.contact.email)) {
                return this.$toast.add({
                    severity: 'error',
                    summary: 'Invalid Format',
                    detail: 'Please enter a valid email address',
                    life: 3000,
                });
            }

            if (!this.contact.phone) {
                return this.$toast.add({
                    severity: 'error',
                    summary: 'Required Field',
                    detail: 'Phone number is required',
                    life: 3000,
                });
            }

            // Phone format validation
            if (!this.isValidPhone(this.contact.phone)) {
                return this.$toast.add({
                    severity: 'error',
                    summary: 'Invalid Format',
                    detail: 'Please enter a valid phone number (e.g., (123) 123-1234, 123-123-1234, +1 415 555 2671)',
                    life: 3000,
                });
            }

            // Check for existing primary contact
            const existingPrimary = this.contacts.some(c =>  {

                console.log("Values >>", {"C": c, "EI": this.editIndex, "CI": this.contacts.indexOf(c)})
                return  c.isPrimary && 
                (this.editIndex === null || this.contacts.indexOf(c) !== this.editIndex)
                }
                );
            
            if (this.contact.isPrimary && existingPrimary) {
                return this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Only one primary contact is allowed',
                    life: 3000,
                });
            }

            // Trim all string values
            if (this.contact.name) this.contact.name = this.contact.name.trim();
            if (this.contact.title) this.contact.title = this.contact.title.trim();
            if (this.contact.email) this.contact.email = this.contact.email.trim();
            if (this.contact.phone) this.contact.phone = String(this.contact.phone).trim();

            this.checkAndUpdateEscalationContact();

            if (this.editIndex === null) {
                this.contacts = [...this.contacts, this.contact];
            } else {
                this.contacts.splice(this.editIndex, 1, this.contact);
                this.editIndex = null;
            }

            this.hideDialog();
            this.validationCall();
        },
        validationCall() {
            // Check if there's at least one primary contact
            const hasPrimaryContact = this.contacts.some(contact => contact.isPrimary);
            const errors = this.v.$silentErrors.length;
            
            if (!hasPrimaryContact) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'At least one primary contact is required',
                    life: 3000,
                });
                // Pass true as first argument to indicate validation error
                this.$emit('submit', true, this.contacts);
            } else {
                // Pass false as first argument to indicate no validation error
                this.$emit('submit', errors, this.contacts);
            }
            this.v.$touch();
        },
    },
};
</script>

<style scoped lang="scss">
// ... [Keep existing styles from ProfileAddress.vue] ...
::v-deep(.p-multiselect) {
    margin: 0.75rem 0;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    margin-bottom: 2rem;
}

::v-deep(.p-inputtext) {
    margin: 0.75rem 0;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
}

.add-new-btn {
    margin-top: 1.6rem !important;
    width: 8rem !important;
    background: #00796b !important;
    border: 2px solid #00796b !important;
    display: block;
    float: right !important;
}

::v-deep(.p-button.p-button-outlined) {
    background-color: transparent !important;
    color: #00796b !important;
    border: 1px solid;
}

::v-deep(.p-toolbar) {
    flex-wrap: wrap;
    background-color: #d6d6d6;
    height: 3rem;
}

::v-deep(.p-button.p-button-icon-only.p-button-rounded) {
    border-radius: 50%;
    height: 2.5rem;
    width: 2.5rem !important;
    margin: 0.5rem;
    background: #ffffff !important;
    border: none !important;
    display: flex;
    float: left !important;
}

::v-deep(.p-button.p-button-icon-only.p-button-rounded):hover {
    background: #e4edd9 !important;
}

::v-deep(.p-datatable) {
    .p-datatable-thead>tr>th {
        color: #707683 !important;
        background: #fbfbfb !important;
        transition: none;
    }
}

.actions-column-inner {
    display: flex;
}

.field {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    margin-bottom: 0.75rem;
}

.field-title {
    margin-left: 1rem;
    font-size: 1.2rem;
    font-weight: 400;
    max-width: 30rem;
}

.confirmation-content {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.table-wrap {
    margin-top: 6rem;
    margin-bottom: 4rem;
    overflow-x: scroll;
}

.toolbar-wrap {
    width: 100%;
    background: #e4edd9;
    align-self: center;
    padding: 0.75rem;
    border-radius: 0.5rem;
    margin-top: 2rem;
}

.error-msg {
    margin-left: 1.25rem;
    color: red;
    font-size: 1rem;
    font-weight: 400;
}

.contacts-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 1rem;
    background: white;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.contacts-table th,
.contacts-table td {
    padding: 0.75rem;
    text-align: left;
    border-bottom: 1px solid #eee;
    max-width: 200px;
    word-wrap: break-word;
    white-space: normal;
}

.contacts-table th {
    background: #fbfbfb;
    color: #707683;
    font-weight: 500;
}

.center-column {
    text-align: center;
}

.center-column i {
    font-size: 1.1rem;
}

.pi-check {
    color: #00796b;
}

.pi-times {
    color: #707683;
}


.mb-1 {
    margin-bottom: 1rem;
}

</style>
